import * as React from 'react';
import type { RestrictionEvent } from 'contracts/restricted-products/restricted-products';
import type { Filters } from 'hooks/store/restricted-products/use-restriction-event-search-params';
import { api, handleApiError, applyQueryString } from 'services/api';

type Payload = {
  filters?: Filters
}

export const useFetchRestrictionEventsReport = () => {
  const fetchRestrictionEventsReport = React.useCallback(async (payload: Payload) => {
    try {
      const url = applyQueryString('/restricted-materials/events', {
        ...payload?.filters,
        all: true,
      });
      const { data } = await api.get<RestrictionEvent[]>(url);
      return data;
    } catch (error) {
      throw handleApiError(error);
    }
  }, []);

  return { fetchRestrictionEventsReport };
};
